import React from 'react';
import '../styles/DocsYouTube.css';

const DocsYouTube = () => {
    return (
        <div className="section docs-youtube-section">
            <div className="container">
                <div className="dy-grid">
                    {/* Docs Section */}
                    <div className="dy-card docs-card">
                        <div className="dy-icon">
                            <i className="fab fa-github"></i>
                        </div>
                        <h2 className="dy-title">오픈소스 문서</h2>
                        <p className="dy-desc">
                            PLC 펌웨어, 센서 라이브러리, ESP32-S3 예제 등 다양한 오픈소스 프로젝트를 GitHub에서 확인하세요.
                        </p>
                        <a href="https://github.com/kdi6033" target="_blank" rel="noreferrer" className="btn btn-outline dy-btn">
                            GitHub 바로가기
                        </a>
                    </div>

                    {/* YouTube Section */}
                    <div className="dy-card youtube-card">
                        <div className="dy-icon">
                            <i className="fab fa-youtube"></i>
                        </div>
                        <h2 className="dy-title">유튜브 채널</h2>
                        <p className="dy-desc">
                            IoT, AI, 자동화에 관한 800개 이상의 영상을 만나보세요. 전문가 튜토리얼과 데모 영상을 통해 학습하세요.
                        </p>
                        <a href="https://www.youtube.com/@i2r-link" target="_blank" rel="noreferrer" className="btn btn-primary dy-btn">
                            영상 보러가기
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocsYouTube;
